<div
    id="app-sidebar-1"
    class="bg-surface-0 dark:bg-surface-900 h-full lg:block shrink-0 absolute lg:static left-0 top-0 border-r border-surface-200 dark:border-surface-700 select-none w-[280px] hidden z-50">
    <div class="flex flex-col h-full">
        <app-menu></app-menu>
    </div>
</div>
